import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, FileCheck2, ScrollText, Workflow, FileBarChart2,
  Wallet, ScanLine, Settings, Download, FileText, Globe, Inbox, Store, Database,
} from 'lucide-react';

const ITEMS = [
  { to: '/crust', label: 'Dashboard', icon: LayoutDashboard, exact: true },
  { to: '/crust/validations', label: 'À valider', icon: FileCheck2 },
  { to: '/crust/crm', label: 'Devis / BC', icon: FileText },
  { to: '/crust/factures', label: 'Factures', icon: ScrollText },
  { to: '/crust/factures-recues', label: 'Fact. reçues', icon: Inbox },
  { to: '/crust/clients-finaux', label: 'Clients finaux', icon: Store },
  { to: '/crust/qonto-downloads', label: 'PDFs Qonto', icon: Download },
  { to: '/crust/circuits', label: 'Circuits', icon: Workflow },
  { to: '/crust/bons-commande', label: 'BC OCR', icon: ScanLine },
  { to: '/crust/bdc-database', label: 'Base BDC', icon: Database },
  { to: '/crust/banque', label: 'Banque', icon: Wallet },
  { to: '/crust/portail', label: 'Portail', icon: Globe },
  { to: '/crust/rapports', label: 'Rapports', icon: FileBarChart2 },
  { to: '/crust/clients', label: 'Réglages', icon: Settings },
];

export default function CrustSubNav() {
  const location = useLocation();
  if (!location.pathname.startsWith('/crust')) return null;
  return (
    <div
      data-testid="crust-sub-nav"
      className="sticky top-0 z-30 -mx-4 md:-mx-6 mb-4 px-4 md:px-6 py-2 bg-surface-elev/90 backdrop-blur-md border-b border-hairline"
    >
      <div className="flex gap-1.5 overflow-x-auto scrollbar-hide -mx-1 px-1">
        {ITEMS.map((it) => {
          const Icon = it.icon;
          const isActive = it.exact
            ? location.pathname === it.to
            : location.pathname.startsWith(it.to);
          return (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={`crust-subnav-${it.label.toLowerCase().replace(/\s+/g, '-')}`}
              className={`shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold transition-all ${
                isActive
                  ? 'bg-[#FF5C00] text-white shadow-sm'
                  : 'text-ink-2 hover:bg-surface-muted hover:text-ink-1'
              }`}
            >
              <Icon className="w-3.5 h-3.5" />
              {it.label}
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}
